<template>
  <div class="container">
    <div
      class="left-menu"
      :style="{
        width: !isCollapse ? '12%' : '4.5%',
        textAlign: !isCollapse ? 'left' : 'center',
      }"
    >
      <left-list :leftIndex="'10'" :isCollapse="isCollapse"></left-list>
    </div>
    <div
      class="right-content"
      :style="{ width: !isCollapse ? '88%' : '95.5%' }"
    >
      <div class="top-nav">
        <top-header @openMenu="openMenu" :isCollapse="isCollapse"></top-header>
      </div>
      <div class="left-list">
        <div class="left-list-title">
          <span>文件管理</span>
        </div>
        <div class="left-list-item left-list-active" @click="leftClick('0')">
          <span>文件列表</span>
        </div>
      </div>
      <div class="right-next">
        <div class="title">
          <span>文件列表</span>
        </div>
        <div class="date-search">
          <el-upload
            class="upload-demo"
            ref="upload"
            :action="$store.state.httpUrl + 'upload/file'"
            name="files"
            list-type="picture"
            :multiple="true"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="uploadSuccess"
          >
            <el-button size="small" type="primary">上传</el-button>
          </el-upload>
        </div>
        <div class="mt-20">
          <el-table
            :data="tableData.data"
            border
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="id"
              label="图片ID"
              width="120"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="date"
              label="缩略图"
              width="200"
              align="center"
            >
              <template slot-scope="scope">
                <el-image
                  style="width: 60%"
                  :src="$store.state.imaUrl + scope.row.path"
                  :preview-src-list="srcList"
                  @click="imageClick(scope.row.path)"
                >
                </el-image>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="date"
              label="文件名"
              width="150"
              align="center"
            >
            </el-table-column> -->
            <el-table-column
              prop="admin_id"
              label="上传者"
              width="150"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="添加时间"
              width="200"
              align="center"
            >
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <!-- <el-button
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                  >大图</el-button
                > -->
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="bottom-paging">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[5, 10, 20, 30, 100]"
            :page-size="num"
            layout="total, prev, pager, next, sizes"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leftList from "../../components/leftList.vue";
import topHeader from "../../components/header.vue"
export default {
  components: {
    leftList,
    topHeader
  },
  inject: ["reload"],
  data() {
    return {
      uploadHeaders: {
        "Remember-Token": localStorage.getItem("rememberToken"),
      },
      srcList: [
        "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
        "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      ],
      tableData: [],
      isCollapse: false,
      fileList: [],
      imageUrl: "",
      page: 1,
      num: 10,
      multipleSelection:[]
    };
  },
  created() {
    this.getFilelist();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    imageClick(url) {
      console.log(url);
      this.srcList = [];
      this.srcList.push(this.$store.state.imaUrl + url);
    },
    uploadSuccess(response, file, fileList) {
      if (response.status == 200) {
        this.$notify({
          title: "提示",
          message: "上传成功！",
          type: "success",
        });
        this.getFilelist();
      } else if (response.status == 400) {
        this.$notify.error({
          title: "提示",
          message: response.message,
        });
        file.status = "fail";
      }

      console.log(response, file, fileList);
    },
    getFilelist() {
      this.$get("get/file", {
        page: this.page,
        num: this.num,
      }).then((res) => {
        this.tableData = res.data.data;
        console.log(res);
      });
    },
    handleAvatarSuccess(res, file) {
      this.$refs["my-upload"].clearFiles();
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    menuitemClick(pushUrl) {
      // console.log(this.$route.path == pushUrl);
      if (this.$route.path == pushUrl) {
        this.reload();
      } else if (pushUrl) {
        this.$router.push(pushUrl);
      } else {
        this.$notify.error({
          title: "提示",
          message: "暂无页面",
        });
        this.reload();
      }
    },
    leftClick(index) {
      if (index == 0 && this.$route.path != "/knowledge") {
        this.$router.push("/knowledge");
      } else if (index == 1) {
        this.$router.push("/knowledgelist");
      } else {
        this.reload();
      }
    },
    knowledgeAdd() {
      this.$router.push("/knowledgeadd");
    },
    openMenu() {
      this.isCollapse = !this.isCollapse;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      this.$confirm("是否删除此文件?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$post("del/file", {
            id: [row.id],
          }).then((res) => {
            if (res.data.status == 200) {
              this.$notify({
                title: "提示",
                message: "删除成功！",
                type: "success",
              });
              this.getFilelist();
            } else if (res.data.status == 400) {
              this.$notify.error({
                title: "提示",
                message: res.data.message,
              });
            }
            console.log(res);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
      console.log(index, row);
    },
  },
};
</script>

<style lang="scss" scoped>
.right-content {
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
  vertical-align: top;
  display: inline-block;
  &::-webkit-scrollbar {
    display: none;
  }
  .date-search {
    margin-top: 30px;
    .el-button {
      padding: 12px 55px;
    }
  }
  .left-list {
    width: 10%;
    height: 93vh;
    overflow-x: hidden;
    overflow-y: scroll;
    font-size: 14px;
    border-right: 20px solid #f2f2f2;
    display: inline-block;
    text-align: center;
    &::-webkit-scrollbar {
      display: none;
    }
    &-title {
      margin: 20px 0;
      font-size: 16px;
    }
    &-item {
      padding: 15px 0;
      cursor: pointer;
      transition: all 0.2s;
      &:hover {
        color: #fff;
        background-color: #3291f8;
      }
    }
    &-active {
      color: #fff;
      background-color: #3291f8;
    }
  }
  .right-next {
    height: 93vh;
    width: 88.5%;
    overflow-x: hidden;
    overflow-y: scroll;
    border-top: 20px solid #f2f2f2;
    padding: 20px;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .title {
    color: #000;
    height: 10px;
    padding-left: 15px;
    line-height: 10px;
    border-left: 5px solid #80c4f8;
    margin-bottom: 10px;
  }

  .top-nav {
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    padding: 15px;

    .left-icon {
      i {
        cursor: pointer;
        color: #3291f8;
        font-size: 30px;
      }

      .el-icon-refresh-right {
        margin-left: 30px;
      }
    }

    .right-user {
      font-size: 14px;

      span {
        vertical-align: middle;
        margin-right: 20px;
      }

      .colse-btn {
        cursor: pointer;
        vertical-align: middle;
        border: 1px solid #999;
        display: inline-block;
        padding: 5px 20px;
        border-radius: 50px;

        span {
          margin-right: 10px;
        }

        i {
          vertical-align: middle;
        }
      }
    }
  }
}

.left-menu {
  display: inline-block;

  .iconyonghuzu {
    font-size: 18px;
    margin: 0 5px;
  }
}

.el-menu {
  width: 100%;
  background-color: #20222a;
  height: 100vh;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  background-color: #20222a;
  color: #fff;
  height: 100vh;
  width: 100%;
}

.el-menu-item:focus,
.el-menu-item:hover {
  color: #000;
  background-color: #ecf5ff;
}

.el-menu-item {
  color: #fff;

  i {
    color: #3291f8;
  }
}

.el-menu-item.is-active {
  background-color: #ecf5ff;
  color: #20222a;
}

.menu-h5 {
  margin: 20px;
  text-align: center;
  font-size: 20px;
}

.menu-icon {
  width: 100%;
  color: #fff;
  box-sizing: border-box;
  padding: 30px 22px;
}
</style>
